import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/composite.json";
import fr from "@/locales/fr/puzzle-types/composite.json";

export const COMPOSITE_NS = "puzzle-types/composite";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerCompositeTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", COMPOSITE_NS))
    i18n.addResourceBundle("en", COMPOSITE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", COMPOSITE_NS))
    i18n.addResourceBundle("fr", COMPOSITE_NS, fr, true, true);
}
